/* eslint-disable */
(function() {
  var $ = require('jquery');
  require('fancybox-core');
  require('fancybox-media');

  var $fancybox = $('.fancybox');

  $fancybox.fancybox({
    openEffect: 'none',
    closeEffect: 'none',
    helpers: {
      media: {},
    },
  });
})();
